import { render, staticRenderFns } from "./OptionBase.vue?vue&type=template&id=faf4b09e"
import script from "./OptionBase.vue?vue&type=script&lang=js"
export * from "./OptionBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports